import { create } from "zustand";

interface ProjectSelectionState {
  hasActiveSelection: boolean;
  setHasActiveSelection: (hasSelection: boolean) => void;
  reset: () => void;
}

/**
 * Store for tracking whether the user has active shift selections in a project. Used to
 * conditionally hide the tab bar when selections are made.
 */
export const useProjectSelectionStore = create<ProjectSelectionState>((set) => ({
  hasActiveSelection: false,
  setHasActiveSelection: (hasSelection: boolean) => set({ hasActiveSelection: hasSelection }),
  reset: () => set({ hasActiveSelection: false }),
}));
